// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
export enum WizardDeviceStepsEnum {
	Organization = 0,
	LocationGroups = 1,
	LocationFacilities = 2,
	CreateLocation = 3,
	DeviceProvision = 4,
	SetupDeviceInRealWorld = 5,
	DeviceToMap = 6,
	MappingShapes = 7,
	DeviceConfiguration = 8,
	Finish = 9,
}

export const WizardDeviceStepsEnumDisplayNames: { [key in keyof typeof WizardDeviceStepsEnum]?: string} = {
	"Organization": "Organization",
	0 : "Organization",
	"LocationGroups": "LocationGroups",
	1 : "LocationGroups",
	"LocationFacilities": "LocationFacilities",
	2 : "LocationFacilities",
	"CreateLocation": "CreateLocation",
	3 : "CreateLocation",
	"DeviceProvision": "DeviceProvision",
	4 : "DeviceProvision",
	"SetupDeviceInRealWorld": "SetupDeviceInRealWorld",
	5 : "SetupDeviceInRealWorld",
	"DeviceToMap": "DeviceToMap",
	6 : "DeviceToMap",
	"MappingShapes": "MappingShapes",
	7 : "MappingShapes",
	"DeviceConfiguration": "DeviceConfiguration",
	8 : "DeviceConfiguration",
	"Finish": "Finish",
	9 : "Finish",
}

export const getWizardDeviceStepsEnumDisplayName = (key: WizardDeviceStepsEnum | (keyof typeof WizardDeviceStepsEnum & string)) => {
	return WizardDeviceStepsEnumDisplayNames[key];
}

